module.exports = __webpack_public_path__ + "static/media/cert_79.c26335d0.jpg";